"use client";

import { useEffect } from "react";
import {
  useWebInfoDetail,
  useWebInfoSave,
} from "../../../hooks/api/web-info/hooks";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm, Controller } from "react-hook-form";
import * as yup from "yup";
import toast from "react-hot-toast";
import { Form, Input, Button } from "antd";
import UploadFoodImage from "../../../lib/UploadFoodImage";
import { WebInfoType } from "@src/types/api/webInfo";
import TinyMce from "../../../views/components/TinyMce";

// ---------------- Validation ----------------
const schema = yup.object({
  description: yup.string().required("Description is required"),
  title: yup.string().required("Title is Required"),
});

type FooterFormType = yup.InferType<typeof schema>;

const WebPages = ({ type }: { type: WebInfoType }) => {
  const { data: details } = useWebInfoDetail(type);

  const { mutate: saveForm, isPending } = useWebInfoSave({
    onSuccess: () => toast.success("Saved successfully"),
    onError: (error: any) =>
      toast.error(error?.message || "Something went wrong"),
  });

  const {
    control,
    handleSubmit,
    reset,
    watch,
    setValue,
    formState: { errors },
  } = useForm<FooterFormType>({
    resolver: yupResolver(schema),
    defaultValues: {
      description: "",
      title: "",
    },
  });

  // ---------------- Prefill (Edit mode) ----------------
  useEffect(() => {
    if (details?.data) {
      reset({
        description: details.data.description || "",
        title: details.data.title || "",
      });
    }
  }, [details?.data?._id]);

  // ---------------- Submit ----------------
  const onSubmit = (values: FooterFormType) => {
    let payload: any = {
      type,
      description: values.description,
      title: values.title,
    };

    if (details?.data?._id) {
      payload._id = details?.data?._id;
    }
    saveForm(payload);
  };

  return (
    <div className="w-full mx-auto">
      <Form layout="vertical" onFinish={handleSubmit(onSubmit)}>
        <div className=" p-6 bg-[#fdf0e3] rounded-xl ">
          <Form.Item label="Title" required>
            <Controller
              name="title"
              control={control}
              render={({ field }) => (
                <Input {...field} placeholder="Enter Title" />
              )}
            />
          </Form.Item>

          {/* DESCRIPTION */}
          <Form.Item label="Description" required>
            <Controller
              name="description"
              control={control}
              render={({ field }) => (
                <TinyMce
                  value={watch("description")}
                  onChange={(value) => setValue("description", value)}
                />
              )}
            />
          </Form.Item>
        </div>

        {/* BUTTON */}
        <div className="mt-6 flex justify-start">
          <Button
            type="primary"
            htmlType="submit"
            loading={isPending}
            className="bg-primary px-10 "
          >
            {isPending ? "Saving..." : "Save"}
          </Button>
        </div>
      </Form>
    </div>
  );
};

export default WebPages;
